import { Button } from "@light-technology/components";
import { type ReactNode } from "react";

type FormCardProps = {
  name: string;
  subtext?: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
  customButton?: ReactNode;
  textCancel?: string;
  onCancel?: () => void;
  "data-ph-capture-attribute-action"?: string;
} & (
  | {
      customButton: ReactNode;
      buttonText?: never;
      onButtonClick?: never;
      isLoading?: never;
      isDisabled?: never;
    }
  | {
      customButton?: never;
      buttonText: string;
      onButtonClick: () => void;
      isLoading?: boolean;
      isDisabled?: boolean;
    }
  | {
      customButton?: never;
      buttonText?: never;
      onButtonClick?: never;
      isLoading?: never;
      isDisabled?: never;
    }
);

export const FormCard = (props: FormCardProps) => {
  const hasPrimaryButton =
    props.customButton !== undefined || props.buttonText !== undefined;
  const hasCancelButton = Boolean(props.textCancel && props.onCancel);

  return (
    <div className="rounded-xl border border-secondary p-3xl">
      <div className="mb-3xl space-y-md">
        {props.headerAction ? (
          <div className="flex items-center justify-between">
            <div className="text-lg font-semibold">{props.name}</div>
            {props.headerAction}
          </div>
        ) : (
          <div className="text-lg font-semibold">{props.name}</div>
        )}
        {props.subtext && (
          <div className="text-sm text-tertiary">{props.subtext}</div>
        )}
      </div>
      {props.children}
      {(hasPrimaryButton || hasCancelButton) && (
        <div className="mt-3xl space-x-lg">
          {props.textCancel && props.onCancel && (
            <Button color="secondary" size="md" onClick={props.onCancel}>
              {props.textCancel}
            </Button>
          )}
          {props.customButton}
          {props.buttonText && (
            <Button
              color="primary"
              size="md"
              isDisabled={props.isDisabled}
              isLoading={props.isLoading}
              onClick={props.onButtonClick}
              data-ph-capture-attribute-action={
                props["data-ph-capture-attribute-action"]
              }
            >
              {props.buttonText}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
